import React, { useEffect } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import Modal from "react-modal";
import { welcomeSelect } from "../../redux/selector/welcomeSelector";
import {
  ErrorPanel,
  InfoPanel,
  SuccessPanel,
  WarningPanel,
  GrayAreaPanel,
  BlankAreaPanel
} from "../../components/MessagePanels/Panels";
import {
  Header,
  SubHeader,
  Button,
  LineSeperator,
  NavigationLinkButton,
  ErrorMark
} from "../../components/RegularComponents";
import { AgentCard } from "../../components/AgentCard/AgentCard";
import { useState } from "react";
import { replaceUrlParams } from "../../app/utils";
import Navigation from "../Navigation";
import * as CONST from "../../app/constants";
import {
  ADDITIONAL_APPLICATION_TYPE_OPTIONS,
  resetWelcomeDialogDisplay,
  setAgentSort,
  setAgentSubFilter
} from "../../redux/slice/welcomeSlice";
import "./Welcome.styles.scss";
import {
  markDeleteAllApplications,
  saveBusinessLicenceApplicationData
} from "../../redux/slice/businessLicenceApplicationSlice";
import {
  // AGENT_SORT_TYPES,
  AGENT_SORT_TYPES,
  STATUS_BY_OPTIONS
} from "../../redux/slice/welcomeSlice";

import { DOCUMENT_CONTENT_TYPE_PDF } from "../../app/constants";
import { fetchBusinessLicnecePDF } from "../../redux/slice/bltDecisionSlice";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import {
  setCurrentAgentApplicationId,
  removeAgentApplication,
  addAgentApplication,
  setBranchApplicationsForRenewal,
  setCurrentAgentApplicationForRenewal,
  setCurrentBranchApplicationId
} from "../../redux/slice/additionalApplicationsSlice";
import { fetchApplicationWithIdAndSetStore } from "../../redux/slice/collectionApplicationSlice";
import { fetchRjscFromNumberAndSetDetails } from "../../redux/slice/rjscSearchSlice";
import {
  BusinessLicenceDataInitObject,
  IsInternalId,
  saveSegueDetails,
  setAgencyApplication,
  // setAgencyApplicationLicenceStatus,
  setAgencyDataForRenewal
} from "../../redux/slice/primaryAgencyApplicationSlice";
import { fetchApplicationWithId } from "../../redux/slice/bltHomeSlice";
import { convertFileDataForUrl } from "../../app/documentUploadUtils";
import {
  applicationTypeFromLicenceSubType,
  isAgencyTypeApplication,
  isCollectionOrDebtAgencyLicence,
  isCollectionTypeApplication,
  isMortgageMainAgentTypeApplication,
  isMortgageTypeApplication,
  isRenewalTypeApplication
} from "../../redux/slice/applicationsUtils";
import { fetchArchiveApplicationsForOriginalId } from "../../redux/slice/archiveApplicationsSlice";
import { BranchCard } from "../../components/BranchCard/BranchCard";

function Welcome(props) {
  const WELCOME_NOTE_PAYMENT_CONFIRMATION_STRING =
    "Your application has been submitted. You will receive a payment receipt by email " +
    "and Business Licensing will contact you if additional information is required.";

  const WELCOME_NOTE_RENEWAL_PAYMENT_CONFIRMATION_STRING =
    "Your renewal application has been submitted. You will receive a payment receipt by email " +
    "and Business Licensing will contact you if additional information is required.";

  const { dispatch } = props;
  const { applicationType, applicationMode } = props.match.params;
  const welcome = props.welcome[applicationType] ? props.welcome[applicationType] : props.welcome;
  const {
    agencyRenewalDetails,
    agencyApplicationDetails,
    agentApplications,
    welcomeNote,
    applicationStatus,
    agentFilterOptions,
    branchApplications
  } = props.welcome;
  const [showWelcomeDialog, setShowWelcomeDialog] = useState(
    applicationMode === CONST.APPLICATION_MODE_RENEW ? false : welcome.dialogDisplay
  );

  const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
  const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fetchingApplicationData, setFetchingApplicationData] = useState(false);
  // const [showLicenceCancelDialog, setShowLicenceCancelDialog] = useState(false);

  // For now create a application from hard coded data
  // agentApplications.push({
  //     licenceStatus:"ACTIVE",
  //     licenceNumber: "12345",
  //     endDate: "March 31, 2021",
  //     agentName: "Test Agent Smith"
  // })

  useEffect(() => {
    if (
      props.welcome.id &&
      props.welcome.agencyApplication &&
      !props.welcome.agencyApplication.businessLicenceData
    ) {
      dispatch(fetchApplicationWithIdAndSetStore(props.welcome.id)).then((latestApplication) => {
        if (!latestApplication.businessLicenceData) {
          latestApplication = Object.assign({}, latestApplication, {
            businessLicenceData: BusinessLicenceDataInitObject()
          });
          dispatch(setAgencyApplication(latestApplication));
        }
      });
    }
  }, [props.welcome.id, props.welcome.agencyApplication, dispatch]);

  const onSortFitlerChange = (e) => {
    props.dispatch(setAgentSort(e.target.value));
  };

  const handleAddNewAgent = () => {
    if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
      handleAddNewBrokerClick();
    } else {
      handleAddNewCollectorClick();
    }
  };

  const handleAddNewBranch = () => {
    props.dispatch(
      push(
        replaceUrlParams(
          CONST.ROUTE_PATH.NEW_BRANCH_APPLICATION_DETAILS,
          applicationType,
          applicationMode
        )
      )
    );
  };

  const viewBranchDetails = (branchApplicationId) => {
    props.dispatch(setCurrentBranchApplicationId(branchApplicationId));
    props.dispatch(
      push(
        replaceUrlParams(CONST.ROUTE_PATH.CURRENT_BRANCH_DETAILS, applicationType, applicationMode)
      )
    );
  };

  const handleAddNewCollectorClick = () => {
    let appType = CONST.APPLICATION_TYPE_COLLECTOR;

    if (applicationType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY)
      appType = CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT;
    else if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE)
      appType = CONST.APPLICATION_TYPE_MORTGAGE_ASSOCIATE_BROKER_LICENCE;

    props.dispatch(
      push(replaceUrlParams(CONST.ROUTE_PATH.COLLECTOR_BEFORE_START, appType, applicationMode))
    );
  };

  const handleAddNewBrokerClick = () => {
    let appType = CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;

    props.dispatch(
      push(
        replaceUrlParams(
          `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_ASSOCIATE_BEFORE_YOU_START}`,
          appType,
          applicationMode
        )
      )
    );
  };

  const handleChangeMainAgentClick = () => {
    props.dispatch(
      push(`${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_REASON}`)
    );
  };

  /*
  const onCancelLicenceButtonClick = () => {
    setShowLicenceCancelDialog(true);
  };

  const handleCancelAgencyLicence = () => {
    dispatch(setAgencyApplicationLicenceStatus(CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT));

    if (agentApplications?.length) {
      dispatch(
        setAllAgentLicenceStatus({
          licenceStatus: CONST.LICENCE_STATUS_WITHDRAWN_BY_CLIENT
        })
      );
    }

    dispatch(saveBusinessLicenceApplicationData(applicationType))
      .then((applicationItem) => {
        setShowLicenceCancelDialog(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  */

  const handleFileUploadClick = () => {
    props.dispatch(push(`${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_FILE_UPLOAD_VIEW}`));
  };

  const welcomeNoteComponent = () => {
    // show a generic payment successful message in the welcome note
    // this flag is passed in the LaunchPage flow as part of paymnet
    // segue flow.
    if (props.location.state && props.location.state.showPaymentConfirmation) {
      if (isRenewalTypeApplication(props.welcome.agencyApplication)) {
        return <SuccessPanel>{WELCOME_NOTE_RENEWAL_PAYMENT_CONFIRMATION_STRING}</SuccessPanel>;
      } else {
        return <SuccessPanel>{WELCOME_NOTE_PAYMENT_CONFIRMATION_STRING}</SuccessPanel>;
      }
    }

    if (welcomeNote.mode === "success") {
      return <SuccessPanel>{welcomeNote.text}</SuccessPanel>;
    } else if (welcomeNote.mode === "none") {
      return <GrayAreaPanel>{welcomeNote.text}</GrayAreaPanel>;
    } else if (welcomeNote.mode === "error") {
      return <ErrorPanel>{welcomeNote.text}</ErrorPanel>;
    } else if (welcomeNote.mode === "info") {
      return <InfoPanel>{welcomeNote.text}</InfoPanel>;
    } else if (welcomeNote.mode === "warning") {
      return <WarningPanel>{welcomeNote.text}</WarningPanel>;
    } else if (welcomeNote.mode === "blank") {
      return (
        <BlankAreaPanel>
          <span dangerouslySetInnerHTML={{ __html: welcomeNote.text }}></span>
        </BlankAreaPanel>
      );
    }

    return null;
  };

  const handleResumeRenewalButtonClick = () => {
    handleRenewalRequestButtonClick(true);
  };
  /*
   */
  const handleStartNewApplication = () => {
    // mark all applications as deleted
    setFetchingApplicationData(true);
    dispatch(markDeleteAllApplications())
      .then(() => {
        // trigger the login kind of flow again
        // this flow will take care of creating a new application id
        dispatch(
          saveSegueDetails({
            name: CONST.SEGUE_NAME.LOGIN,
            applicationType,
            applicationMode
          })
        );
        window.location.assign(CONST.ROUTE_PATH.LAUNCHPAGE);
      })
      .catch((err) => {
        setFetchingApplicationData(false);

        console.error(err);
      });
  };
  /*
   * set the agency licencingSubType to *RENEW*
   * keep the data in the changes folder
   */
  const handleRenewalRequestButtonClick = (isResumingDraftApplication) => {
    const { dispatch } = props;

    const moveToNext = (agencyApplication) => {
      let nextUrl = CONST.ROUTE_PATH.RJSC_DETAIL_RENEW_REVIEW;

      if (isMortgageTypeApplication(applicationType)) {
        nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_PB}`;
      } else if (
        applicationType === CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
        applicationType === CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE
      ) {
        nextUrl = `${CONST.ROUTE_PATH.RJSC_DETAIL_RENEW_REVIEW}`;
      }

      setFetchingApplicationData(false);

      dispatch(
        push({
          pathname: replaceUrlParams(nextUrl, applicationType, CONST.APPLICATION_MODE_RENEW)
        })
      );
    };

    // MRA-1253 We need to fetch RJSC information every time Renew or Resume Renew flow is triggered
    // so that RJSC is up-to-date when application is submitted. There is no way to check if
    // it is synced or not, that's why its required every time.
    // const needToFetchRjscDetails = (agencyApplication) => (agencyApplication.createdBy === "migrate@migrate.com")

    setFetchingApplicationData(true);

    dispatch(fetchApplicationWithIdAndSetStore(props.welcome.agencyApplication.id))
      .then((data) => {
        if (!isResumingDraftApplication) {
          const proceedToNext = () => {
            dispatch(setAgencyDataForRenewal());
            dispatch(
              setBranchApplicationsForRenewal({
                licenceTypeDetails: props.welcome.licenceTypeDetails
              })
            );

            dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
              .then((data) => {
                dispatch(fetchArchiveApplicationsForOriginalId(props.welcome.agencyApplication.id))
                  .then((archiveData) => {
                    //console.log("archive data fetched...")
                  })
                  .catch((err) => {
                    console.error("error in fetching archive data:  " + err);
                  })
                  .finally(() => {
                    moveToNext(data);
                  });
              })
              .catch((err) => {
                console.error("error in saving application : " + err);
              });
          };

          const rjscNumber =
            data.businessLicenceData?.companyRjscDetails?.businessEntity?.registryNumber;

          if (rjscNumber && !isNaN(parseInt(rjscNumber))) {
            const num = parseInt(rjscNumber);
            if (num > 0) {
              dispatch(fetchRjscFromNumberAndSetDetails(num)).then(() => {
                proceedToNext();
              });
            } else {
              proceedToNext();
            }
          } else {
            proceedToNext();
          }
        } else {
          dispatch(fetchArchiveApplicationsForOriginalId(props.welcome.agencyApplication.id))
            .then((fetchedApplication) => {
              let archivedAgencyApplication = fetchedApplication;

              if (Array.isArray(fetchedApplication)) {
                if (fetchedApplication.length > 1) {
                  const agencyApps = fetchedApplication.filter((app) =>
                    isAgencyTypeApplication(app)
                  );
                  if (agencyApps.length > 0) {
                    archivedAgencyApplication = agencyApps.sort(
                      (app1, app2) => app1.id < app2.id
                    )[0];
                  }
                } else {
                  archivedAgencyApplication = fetchedApplication[0];
                }
              }

              const regNumber = parseInt(
                archivedAgencyApplication?.businessLicenceData?.companyRjscDetails?.businessEntity
                  ?.registryNumber
              );

              if (!isNaN(regNumber) && regNumber > 0) {
                dispatch(fetchRjscFromNumberAndSetDetails(regNumber)).then(() => {
                  dispatch(
                    saveBusinessLicenceApplicationData(applicationType, applicationMode)
                  ).then((savedApplication) => {
                    moveToNext(savedApplication);
                  });
                });
              } else {
                moveToNext(fetchedApplication);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        }
      })
      .catch((err) => {
        setFetchingApplicationData(false);
      });
  };

  // const handleIndividualApplicationRenewalButtonClick = (agentApplication, handleNext) => {
  //   const { dispatch } = props;

  //   dispatch(setCurrentAgentApplicationForRenewal())

  //   const appType = applicationTypeFromLicenceSubType(agentApplication.licencingSubType)
  //   dispatch(saveBusinessLicenceApplicationData(appType, CONST.APPLICATION_MODE_RENEW))
  //   .then(savedData => {
  //     handleNext()
  //   })

  // }

  // const handleChangeRequestButtonClick = () => {
  //   const { dispatch } = props;

  //   const moveToNext = () => {
  //     dispatch(
  //       push({
  //         pathname: replaceUrlParams(
  //           CONST.ROUTE_PATH.APPLICATION_REVIEW,
  //           applicationType,
  //           applicationMode
  //         ),
  //         state: { forChangeRequest: true },
  //       })
  //     );
  //   };

  //   setFetchingApplicationData(true);

  //   dispatch(
  //     fetchApplicationWithIdAndSetStore(props.welcome.agencyApplication.id)
  //   )
  //     .then((data) => {
  //       setFetchingApplicationData(false);
  //       moveToNext();
  //     })
  //     .catch((err) => {
  //       setFetchingApplicationData(false);
  //     });
  // };

  const handleNextScreenNavigation = () => {
    const { dispatch } = props;

    const moveToNext = (agencyApplication) => {
      let nextUrl = welcome?.navigation?.next ?? CONST.ROUTE_PATH.BUSINESS_CONTACT;

      if (
        agencyApplication.licencingSubType ===
        CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION
      ) {
        nextUrl = `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_BROKER_NEXT_STEPS}`;
      } else if (
        agencyApplication.licencingSubType ===
        CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION
      ) {
        nextUrl = `${CONST.ROUTE_PATH.ML_APP}${CONST.ROUTE_PATH.ML_NEXT_STEPS}`;
      } else if (
        agencyApplication.licencingSubType ===
        CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION
      ) {
        nextUrl = `${CONST.ROUTE_PATH.MA_APP}${CONST.ROUTE_PATH.ML_NEXT_STEPS}`;
      } else if (
        agencyApplication.licencingSubType ===
          CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_APPLICATION ||
        agencyApplication.licencingSubType ===
          CONST.LICENCE_SUB_TYPE_INDIVIDUAL_PRINCIPAL_BROKER_RETENTION_APPLICATION
      ) {
        nextUrl = `${CONST.ROUTE_PATH.PB_APP}${CONST.ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION}`;
      } else if (
        agencyApplication.licencingSubType ===
          CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_APPLICATION ||
        agencyApplication.licencingSubType ===
          CONST.LICENCE_SUB_TYPE_INDIVIDUAL_COMPLIANCE_OFFICER_RETENTION_APPLICATION
      ) {
        nextUrl = `${CONST.ROUTE_PATH.CO_APP}${CONST.ROUTE_PATH.MRA_ADD_MAIN_AGENT_CONTACT_INFORMATION}`;
      } else {
        if (
          agencyApplication &&
          agencyApplication.businessLicenceData &&
          agencyApplication.businessLicenceData.registryNumber
        ) {
          // move to business contact details if the registry number is already available
          nextUrl = CONST.ROUTE_PATH.BUSINESS_CONTACT;
        } else {
          nextUrl = CONST.ROUTE_PATH.ROUTE_PATH.RJSC_SEARCH;
        }
      }

      dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)));
    };

    // always fetch the application data first before proceeding
    if (!props.welcome.agencyApplication.businessLicenceData) {
      setFetchingApplicationData(true);
      dispatch(fetchApplicationWithIdAndSetStore(props.welcome.agencyApplication.id))
        .then((data) => {
          const appData = data.businessLicenceData;

          if (0 && appData && appData.registryNumber) {
            dispatch(fetchRjscFromNumberAndSetDetails(appData.registryNumber)).then(() => {
              setFetchingApplicationData(false);
              moveToNext(data);
            });
          } else {
            setFetchingApplicationData(false);
            moveToNext(data);
          }
        })
        .catch((err) => {
          setFetchingApplicationData(false);
        });
    } else {
      moveToNext(props.welcome.agencyApplication);
    }
  };

  const renewalApplicationButtonComponent = () => {
    if (!applicationStatus || applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT) {
      if (isRenewalTypeApplication(props.welcome.agencyApplication)) {
        if (props.welcome.isRenewalEnable) {
          return (
            <Button
              showSpinner={fetchingApplicationData}
              id="next-screen-navigation-resume-button"
              onClick={() => handleResumeRenewalButtonClick()}
              text={"Resume Renewal"}
              buttonType="regular_primary"
            />
          );
        } else if (props.welcome.enableStartNewApplication) {
          return (
            <Button
              showSpinner={fetchingApplicationData}
              id="next-screen-navigation-change-request-button"
              onClick={() => handleStartNewApplication()}
              text={"Start New Application"}
              buttonType="regular_primary"
            />
          );
        }
      }
    } else if (applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
      const retComponents = [];

      if (props.welcome.isRenewalEnable) {
        retComponents.push(
          <Button
            showSpinner={fetchingApplicationData}
            id="next-screen-navigation-resume-button"
            onClick={() => handleRenewalRequestButtonClick()}
            text={"Renew Licence"}
            buttonType="regular_primary"
          />
        );
        /*
        retComponents.push(
          <Button
            style={{ marginLeft: 10 }}
            showSpinner={false}
            id="cancel-app-btn"
            onClick={onCancelLicenceButtonClick}
            text={"Cancel Licence"}
            buttonType="regular_primary"
          />
        );
        */
      }

      retComponents.push(
        <div className="actionButtons">
          <NavigationLinkButton
            text="Print licence"
            className="print-before topMarginNormal"
            onClick={() => {
              getApplicationLicencePDF(props.welcome.id);
            }}
          />
        </div>
      );

      return retComponents;
    }

    return null;
  };
  /*
   * The application button component :
   *  possibilities :
   *   - Resume draft application :
   *      - not a renewal application
   *      - agency is PENDING_PAYMENT
   *   - Renew Application
   *      - not a renewal application
   *      - agency is approved
   *      - current date is in renew range
   *   - Print licence
   *      - application in approved status (main or renewal)
   *      - show only for one of the multiple agency applications (main & archive)
   */
  const applicationButtonComponent = () => {
    if (isRenewalTypeApplication(props.welcome.agencyApplication)) {
      if (
        props.welcome.archiveApplication?.applicationStatus ===
        CONST.APPLICATION_STATUS_APPROVED_ISSUED
      ) {
        return (
          <div className="actionButtons">
            <NavigationLinkButton
              text="Print licence"
              className="print-before topMarginNormal"
              onClick={() => {
                getApplicationLicencePDF(props.welcome.id);
              }}
            />
            {(!(props.welcome.isRenewalEnable || props.welcome.enableStartNewApplication) ||
              props.welcome.agencyApplication?.applicationStatus ===
                CONST.APPLICATION_STATUS_UNREAD ||
              props.welcome.agencyApplication?.applicationStatus ===
                CONST.APPLICATION_STATUS_UNDER_REVIEW ||
              props.welcome.agencyApplication?.applicationStatus ===
                CONST.APPLICATION_STATUS_PENDING ||
              props.welcome.agencyApplication?.applicationStatus ===
                CONST.APPLICATION_STATUS_OPENED) && (
              <Button
                style={{ marginTop: "20px" }}
                id="file-upload-button"
                onClick={handleFileUploadClick}
                text={"Upload file"}
                buttonType="regular_primary"
              />
            )}

            {canChangeMainAgent() ? (
              <Button
                style={{ marginTop: "20px" }}
                id="change-main-agent-button"
                disabled={isMainAgentChangeApplicationInProgress()}
                onClick={handleChangeMainAgentClick}
                text={changeMainAgentButtonTitle()}
                buttonType="regular_primary"
              />
            ) : null}
          </div>
        );
      } else if (
        //Prod issue fix: Show main agent change Button for renewal
        props.welcome.agencyApplication?.applicationStatus ===
          CONST.APPLICATION_STATUS_APPROVED_ISSUED &&
        canChangeMainAgent()
      ) {
        return (
          <div className="actionButtons">
            <Button
              style={{ marginTop: "20px" }}
              id="change-main-agent-button"
              disabled={isMainAgentChangeApplicationInProgress()}
              onClick={handleChangeMainAgentClick}
              text={changeMainAgentButtonTitle()}
              buttonType="regular_primary"
            />
            {!(props.welcome.isRenewalEnable || props.welcome.enableStartNewApplication) && (
              <Button
                style={{ marginTop: "20px" }}
                id="file-upload-button"
                onClick={handleFileUploadClick}
                text={"Upload file"}
                buttonType="regular_primary"
              />
            )}
          </div>
        );
      } else if (
        props.welcome.agencyApplication?.applicationStatus ===
          CONST.APPLICATION_STATUS_APPROVED_ISSUED &&
        !(props.welcome.isRenewalEnable || props.welcome.enableStartNewApplication)
      ) {
        return (
          <div className="actionButtons">
            <Button
              style={{ marginTop: "20px" }}
              id="file-upload-button"
              onClick={handleFileUploadClick}
              text={"Upload file"}
              buttonType="regular_primary"
            />
          </div>
        );
      }
    } else {
      if (
        props.welcome.agencyApplication?.applicationStatus ===
        CONST.APPLICATION_STATUS_APPROVED_ISSUED
      ) {
        return (
          <div className="actionButtons">
            {props.welcome.isRenewalEnable && (
              <Button
                showSpinner={fetchingApplicationData}
                id="next-screen-navigation-change-request-button"
                onClick={() => handleRenewalRequestButtonClick()}
                text={"Renew Licence"}
                buttonType="regular_primary"
              />
            )}

            {props.welcome.enableStartNewApplication && (
              <Button
                showSpinner={fetchingApplicationData}
                id="next-screen-navigation-change-request-button"
                onClick={() => handleStartNewApplication()}
                text={"Start New Application"}
                buttonType="regular_primary"
              />
            )}

            {props.welcome.agencyApplication?.licenceStatus !== CONST.LICENCE_STATUS_EXPIRED && (
              <NavigationLinkButton
                text="Print licence"
                className="print-before topMarginNormal"
                onClick={() => {
                  getApplicationLicencePDF(props.welcome.id);
                }}
              />
            )}

            {canChangeMainAgent() && (
              <Button
                style={{ marginTop: "20px" }}
                id="change-main-agent-button"
                disabled={isMainAgentChangeApplicationInProgress()}
                onClick={handleChangeMainAgentClick}
                text={changeMainAgentButtonTitle()}
                buttonType="regular_primary"
              />
            )}

            {!(props.welcome.isRenewalEnable || props.welcome.enableStartNewApplication) && (
              <Button
                style={{ marginTop: "20px" }}
                id="file-upload-button"
                onClick={handleFileUploadClick}
                text={"Upload file"}
                buttonType="regular_primary"
              />
            )}
          </div>
        );
      } else if (
        (props.welcome.isRenewalEnable ||
          props.welcome.licenceStatus === CONST.LICENCE_STATUS_NEW) &&
        props.welcome.agencyApplication?.applicationStatus ===
          CONST.APPLICATION_STATUS_PENDING_PAYMENT
      ) {
        return (
          <Button
            showSpinner={fetchingApplicationData}
            id="next-screen-navigation-resume-button"
            onClick={handleNextScreenNavigation}
            text={"Resume Application"}
            buttonType="regular_primary"
          />
        );
      } else if (
        props.welcome.agencyApplication?.applicationStatus === CONST.APPLICATION_STATUS_UNREAD ||
        props.welcome.agencyApplication?.applicationStatus ===
          CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        props.welcome.agencyApplication?.applicationStatus === CONST.APPLICATION_STATUS_PENDING ||
        props.welcome.agencyApplication?.applicationStatus === CONST.APPLICATION_STATUS_OPENED
      ) {
        return (
          <div className="actionButtons">
            <Button
              style={{ marginTop: "20px" }}
              id="file-upload-button"
              onClick={handleFileUploadClick}
              text={"Upload file"}
              buttonType="regular_primary"
            />
          </div>
        );
      }
    }

    // if (
    //   !applicationStatus ||
    //   applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT
    // ) {
    //   if(props.welcome.isRenewalEnable &&
    //       isRenewalTypeApplication(props.welcome.agencyApplication)) {
    //         return (
    //           <div className="actionButtons">
    //             <Button
    //               showSpinner={fetchingApplicationData}
    //               id="next-screen-navigation-resume-button"
    //               onClick={handleRenewalRequestButtonClick}
    //               text={"Resume Renewal"}
    //               buttonType="regular_primary"
    //               />
    //           </div>
    //         );
    //   } else {
    //     return (
    //       <Button
    //         showSpinner={fetchingApplicationData}
    //         id="next-screen-navigation-resume-button"
    //         onClick={handleNextScreenNavigation}
    //         text={"Resume Application"}
    //         buttonType="regular_primary"
    //       />
    //     );
    //   }
    // } else if (applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED) {
    //   return (
    //     <div className="actionButtons">
    //       {/* <Button
    //                     showSpinner={fetchingApplicationData}
    //                     id="next-screen-navigation-change-request-button"
    //                     onClick={handleChangeRequestButtonClick}
    //                     text={"Request change"}
    //                     buttonType="regular_primary"
    //                 /> */}

    //       {(props.welcome.isRenewalEnable &&
    //         !isRenewalTypeApplication(props.welcome.agencyApplication))
    //         &&
    //         <Button
    //             showSpinner={fetchingApplicationData}
    //             id="next-screen-navigation-change-request-button"
    //             onClick={handleRenewalRequestButtonClick}
    //             text={"Renew Application"}
    //             buttonType="regular_primary"
    //         />
    //       }

    //       <NavigationLinkButton
    //         text="Print licence"
    //         className="print-before topMarginNormal"
    //         onClick={() => {
    //           getApplicationLicencePDF(props.welcome.id);
    //         }}
    //       />
    //     </div>
    //   );
    // }

    return null;
  };

  const handleAgentCardAction = (action, agentApplicationId, licencingSubType) => {
    //props.dispatch(setCurrentCollectorFromApplicationId(agentApplicationId))

    const actionHandler = (agentApplication) => {
      dispatch(setCurrentAgentApplicationId(agentApplicationId));

      let appType = CONST.APPLICATION_TYPE_COLLECTOR;

      if (applicationType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY)
        appType = CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT;

      if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE)
        appType = CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;

      if (
        action === "continue_draft" &&
        (appType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENT ||
          appType === CONST.APPLICATION_TYPE_COLLECTOR)
      ) {
        props.dispatch(
          push(
            replaceUrlParams(
              CONST.ROUTE_PATH.COLLECTOR_DETAILS,
              appType,
              CONST.APPLICATION_MODE_NEW
            )
          )
        );
      } else if (
        action === "continue_draft" &&
        appType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
      ) {
        // check if the personData field has any details.
        if (
          licencingSubType === CONST.LICENCE_SUB_TYPE_ASSOCIATE_MORTGAGE_BROKER_NEW_APPLICATION ||
          licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION
        ) {
          props.dispatch(
            push(
              replaceUrlParams(
                CONST.ROUTE_PATH.MRA_APP + CONST.ROUTE_PATH.MRA_CURRENTLY_BROKER_IN_NS,
                appType,
                CONST.APPLICATION_MODE_NEW
              )
            )
          );
        } else {
          props.dispatch(
            push(
              replaceUrlParams(
                CONST.ROUTE_PATH.MRA_APP + CONST.ROUTE_PATH.MRA_IS_CANADA_RESIDENT,
                appType,
                CONST.APPLICATION_MODE_NEW
              )
            )
          );
        }
      } else if (action === "remove") {
        props.dispatch(removeAgentApplication(agentApplicationId));
        // just set any individual mortgage type application as first param below
        props.dispatch(
          saveBusinessLicenceApplicationData(
            CONST.APPLICATION_TYPE_MORTGAGE_INDIVIDUAL_BROKER_LICENCE,
            CONST.APPLICATION_MODE_NEW
          )
        );
      } else if (action === "print_licence") {
        getApplicationLicencePDF(agentApplicationId);
      } else if (action === "agent_details") {
        props.dispatch(
          push(
            replaceUrlParams(
              CONST.ROUTE_PATH.AGENT_DETAILS + `/${agentApplicationId}`,
              appType,
              CONST.APPLICATION_MODE_NEW
            )
          )
        );
      } else if (action === "renew_application" || action === "resume_application") {
        const moveNext = () => {
          dispatch(
            push(
              `${CONST.ROUTE_PATH.MRA_APP}${CONST.ROUTE_PATH.MRA_RENEWAL_BROKER_CONTACT_INFORMATION}`
            )
          );
        };

        if (action === "renew_application") {
          const appType = applicationTypeFromLicenceSubType(agentApplication.licencingSubType);

          if (
            isMortgageTypeApplication(appType) &&
            !isRenewalTypeApplication(props.welcome.agencyApplication)
          ) {
            // first set the brokerage application to renewal, save it and then proceed.
            dispatch(setAgencyDataForRenewal());
            dispatch(
              saveBusinessLicenceApplicationData(
                CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
                CONST.APPLICATION_MODE_RENEW
              )
            ).then((savedAgencyApplication) => {
              dispatch(setCurrentAgentApplicationForRenewal());

              dispatch(
                saveBusinessLicenceApplicationData(appType, CONST.APPLICATION_MODE_RENEW)
              ).then((savedData) => {
                moveNext();
              });
            });
          } else {
            dispatch(setCurrentAgentApplicationForRenewal());

            dispatch(
              saveBusinessLicenceApplicationData(appType, CONST.APPLICATION_MODE_RENEW)
            ).then((savedData) => {
              moveNext();
            });
          }
        } else {
          moveNext();
        }
      }
    };

    // need to fetch the businessLicenceData if not present already
    if (!IsInternalId(agentApplicationId)) {
      dispatch(fetchApplicationWithId(agentApplicationId)).then((latestAgentApplication) => {
        if (latestAgentApplication && latestAgentApplication.businessLicenceData)
          dispatch(addAgentApplication(latestAgentApplication));

        actionHandler(latestAgentApplication);
      });
    } else {
      actionHandler();
    }
  };

  const handleBranchApplicationAction = (action, branchApplicationId) => {
    if (action === "continue_draft") {
      handleAddNewBranch();
    } else if (action === "branch_details") {
      viewBranchDetails(branchApplicationId);
    }
  };

  const getApplicationLicencePDF = async (applicationId) => {
    const pdf = await fetchBusinessLicnecePDF(applicationId);
    let fileDataUrl = convertFileDataForUrl(pdf.file, DOCUMENT_CONTENT_TYPE_PDF);
    setDocumentViewerDocument(fileDataUrl);
    setSelectedFile(pdf);
    setOpenDocumentViewer(true);
  };

  const canShowAgentDetailsSection = () => {
    const agencyApplicationType = applicationTypeFromLicenceSubType(
      props.welcome.agencyApplication?.licencingSubType
    );
    return (
      isCollectionTypeApplication(agencyApplicationType) ||
      (isMortgageTypeApplication(agencyApplicationType) &&
        !isMortgageMainAgentTypeApplication(agencyApplicationType))
    );
  };

  const canShowBranchApplications = () => {
    const agencyApplicationType = applicationTypeFromLicenceSubType(
      props.welcome.agencyApplication?.licencingSubType
    );
    return isCollectionTypeApplication(agencyApplicationType);
  };

  const agentApplicationDetailsComponent = () => {
    if (
      props.welcome.additionalApplicationTypeFilter === ADDITIONAL_APPLICATION_TYPE_OPTIONS.BRANCHES
    ) {
      return null;
    }

    let agentTypeText = "individual agent";

    if (applicationType === CONST.APPLICATION_TYPE_COLLECTION_AGENCY) {
      agentTypeText = "collector";
    } else if (applicationType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY) {
      agentTypeText = "debt management agent";
    } else if (applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
      agentTypeText = "broker";
    }

    if (agentApplications.length > 0) {
      return agentApplications.map((agentApp) => {
        return (
          <AgentCard
            agentApplication={agentApp}
            applicationType={applicationType} //applicationType={"mortage-brokerage-licence"}
            onActionClick={handleAgentCardAction}
            agencyRenewalEnabled={props.welcome.isRenewalEnable}
          />
        );
      });
    } else if (branchApplications.length === 0) {
      if (
        !isCollectionTypeApplication(applicationType) &&
        (props.welcome.applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT ||
        props.welcome.applicationStatus === CONST.APPLICATION_STATUS_DENIED ||
        props.welcome.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT)
      ) {
        let headerText = `No ${agentTypeText} licences yet.`;
        let summaryText = `Complete your agency application before applying for ${agentTypeText} licences.`;

        if (props.welcome.applicationStatus === CONST.APPLICATION_STATUS_DENIED) {
          headerText = `Cannot add ${agentTypeText}.`;
          summaryText = `Your agency application is denied. You can not apply for a ${agentTypeText} licence.`;
        } else if (
          props.welcome.applicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
        ) {
          headerText = `Cannot add ${agentTypeText}.`;
          summaryText = `Your agency application is withdrawn. You can not apply for a ${agentTypeText} licence.`;
        }

        return (
          <div className="diabledAgentBanner">
            <div className="diabledAgentSummary">
              <div>
                <i className="fa fa-id-badge fa-2x"></i>
              </div>
              <div className="diabledAgentSummary_header">{headerText}</div>
              <div className="diabledAgentSummary_text">{summaryText}</div>
            </div>
          </div>
        );
      } else if (canAddIndividualAgent()) {
        return (
          <div>
            <NavigationLinkButton
              text={`Add new ${agentTypeText}`}
              onClick={handleAddNewCollectorClick}
            />
            {`working in your agency for a ${agentTypeText} licence`}
          </div>
        );
      }

      if (isCollectionOrDebtAgencyLicence(props.welcome.agencyApplication?.licencingSubType)) {
        return null;
      }

      return (
        <div className="centered">
          <p className="statusText">{`no ${agentTypeText}`}</p>
        </div>
      );
    }

    return null;
  };

  const branchApplicationDetailsComponent = () => {
    if (
      !canShowBranchApplications() ||
      props.welcome.additionalApplicationTypeFilter === ADDITIONAL_APPLICATION_TYPE_OPTIONS.AGENTS
    ) {
      return null;
    }

    if (branchApplications.length > 0) {
      return branchApplications.map((branchApp) => {
        return (
          <BranchCard
            branchApplication={branchApp}
            applicationType={applicationType}
            onActionClick={handleBranchApplicationAction}
            agencyRenewalEnabled={props.welcome.isRenewalEnable}
          />
        );
      });
    }

    return null;
  };

  /*
  const additionalApplicationTypeSelectionControl = () => {
    return (
      <div className="select fw-10">
        <select
          style={{ width: "10em" }}
          id="welcome-sort-status-select"
          name="welcome-sort-status-select"
          value={props.welcome.additionalApplicationTypeFilter}
          onChange={(e) => {
            props.dispatch(setAdditionalApplicationTypeFilter(e.target.value));
          }}
        >
          <option key="sort_status_all" value={ADDITIONAL_APPLICATION_TYPE_OPTIONS.ALL}>
            All
          </option>

          <option key="sort_status_draft" value={ADDITIONAL_APPLICATION_TYPE_OPTIONS.AGENTS}>
            {applicationType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
              ? "Debt management agent"
              : "Collector"}
          </option>

          <option key="sort_status_submitted" value={ADDITIONAL_APPLICATION_TYPE_OPTIONS.BRANCHES}>
            Branches
          </option>
        </select>
      </div>
    );
  };
  */

  const statusTypeSelectionControl = () => {
    return (
      <div className="select fw-10">
        <select
          style={{ width: "10em" }}
          id="welcome-sort-status-select"
          name="welcome-sort-status-select"
          value={props.welcome.agentSubFilter}
          disabled={props.welcome.agentSort !== AGENT_SORT_TYPES.STATUS_VALUE}
          onChange={(e) => {
            props.dispatch(setAgentSubFilter(e.target.value));
          }}
        >
          <option key="sort_status_all" value={STATUS_BY_OPTIONS.ALL}>
            All
          </option>

          <option key="sort_status_draft" value={STATUS_BY_OPTIONS.DRAFT}>
            Draft
          </option>

          <option key="sort_status_submitted" value={STATUS_BY_OPTIONS.PENDING_PAYMENT}>
            Pending payment
          </option>

          <option key="sort_status_submitted" value={STATUS_BY_OPTIONS.SUBMITTED}>
            Submitted
          </option>

          <option key="sort_status_need_action" value={STATUS_BY_OPTIONS.PENDING}>
            Pending
          </option>

          <option key="sort_status_active" value={STATUS_BY_OPTIONS.APPROVED}>
            Approved
          </option>

          <option key="sort_status_reject" value={STATUS_BY_OPTIONS.DENIED}>
            Denied
          </option>

          <option key="sort_status_withdrawn" value={STATUS_BY_OPTIONS.REVOKED}>
            Revoked
          </option>

          <option key="sort_status_withdrawan" value={STATUS_BY_OPTIONS.WITHDRAWN}>
            Withdrawn
          </option>

          <option key="sort_status_suspended" value={STATUS_BY_OPTIONS.SUSPENDED}>
            Suspended
          </option>

          <option key="sort_status_expired" value={STATUS_BY_OPTIONS.EXPIRED}>
            Expired
          </option>
        </select>
      </div>
    );
  };

  const getRenewalApplicationDetailValue = (id, text, applicationStatus) => {
    if (
      id === "licenceStatus" &&
      (!applicationStatus || applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT) &&
      props.welcome.isRenewalEnable
    ) {
      return (
        <NavigationLinkButton
          text="Renewal Started"
          onClick={() => handleResumeRenewalButtonClick()}
        />
      );
    }

    return <span className="statusTextPadding">{text}</span>;
  };

  const getApplicationDetailValue = (id, text, applicationStatus) => {
    if (
      id === "licenceStatus" &&
      (!applicationStatus || applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT)
    ) {
      return (
        <NavigationLinkButton text="Application Started" onClick={handleNextScreenNavigation} />
      );
    }

    return <span className="statusTextPadding">{text}</span>;
  };

  // MRA-1299 : disable "add a broker" button on the brokerage homepage
  // until the PB/Brokerage app is submitted
  const canAddMortgageBroker = () => {
    const mainAppLicencingSubType = props.welcome.agencyApplication?.licencingSubType;
    const mainApplicationStatus =
      props.welcome.agencyApplication?.applicationStatus ??
      CONST.APPLICATION_STATUS_PENDING_PAYMENT;

    if (
      mainAppLicencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION &&
      !(
        props.welcome.licenceStatus === CONST.LICENCE_STATUS_EXPIRED ||
        mainApplicationStatus === CONST.APPLICATION_STATUS_DENIED ||
        mainApplicationStatus === CONST.APPLICATION_STATUS_CANCELLED ||
        mainApplicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED ||
        mainApplicationStatus === CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT
      )
    ) {
      return true;
    }

    const pbApplications = agentApplications.filter(
      (agentApp) =>
        agentApp.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
        agentApp.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
    );
    let pbApplicationStatus = CONST.APPLICATION_STATUS_PENDING_PAYMENT;

    if (pbApplications?.length === 1) {
      pbApplicationStatus = pbApplications[0].applicationStatus;
    }

    if (
      mainApplicationStatus !== CONST.APPLICATION_STATUS_PENDING_PAYMENT &&
      pbApplicationStatus !== CONST.APPLICATION_STATUS_PENDING_PAYMENT
    ) {
      switch (mainApplicationStatus) {
        case CONST.APPLICATION_STATUS_APPROVED_ISSUED:
          if (props.welcome.licenceStatus === CONST.LICENCE_STATUS_EXPIRED) {
            return false;
          }
          return true;

        case CONST.APPLICATION_STATUS_UNREAD:
        case CONST.APPLICATION_STATUS_OPENED:
        case CONST.APPLICATION_STATUS_UNDER_REVIEW:
          return true;

        case CONST.APPLICATION_STATUS_DENIED:
        case CONST.APPLICATION_STATUS_CANCELLED:
        case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
        case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
          return false;

        default:
          return false;
      }
    }

    return false;
  };

  const canAddIndividualAgent = () => {
    // renewal application in draft status and renewal period has expired.
    // A new individual application can not be added.
    if (
      isRenewalTypeApplication(props.welcome.agencyApplication) &&
      props.welcome.agencyApplication.applicationStatus ===
        CONST.APPLICATION_STATUS_PENDING_PAYMENT &&
      !props.welcome.isRenewalEnable
    ) {
      return false;
    }

    // MRA-1299 : disable "add a broker" button on the brokerage homepage
    // until the PB/Brokerage app is submitted
    if (isMortgageTypeApplication(applicationType)) {
      return canAddMortgageBroker();
    }

    //Add collector not required MRA-1508
    if (isCollectionOrDebtAgencyLicence(props.welcome.agencyApplication?.licencingSubType)) {
      return false;
    }

    switch (props.welcome.applicationStatus) {
      case CONST.APPLICATION_STATUS_APPROVED_ISSUED:
        if (props.welcome.licenceStatus === CONST.LICENCE_STATUS_EXPIRED) {
          return false;
        }
        return true;
      case CONST.APPLICATION_STATUS_PENDING:
      case CONST.APPLICATION_STATUS_PENDING_PAYMENT:
      case CONST.APPLICATION_STATUS_UNREAD:
      case CONST.APPLICATION_STATUS_OPENED:
      case CONST.APPLICATION_STATUS_UNDER_REVIEW:
        return true;
      case CONST.APPLICATION_STATUS_DENIED:
      case CONST.APPLICATION_STATUS_CANCELLED:
      case CONST.APPLICATION_STATUS_WITHDRAWN_APPROVED:
      case CONST.APPLICATION_STATUS_WITHDRAWN_BY_CLIENT:
        return false;
      default:
        return false;
    }
  };

  const canChangeMainAgent = () => {
    const { licencingSubType, applicationStatus, licenceStatus } =
      props.welcome.agencyApplication ?? {};

    if (
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_RENEWAL_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_CHANGE_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION ||
      licencingSubType === CONST.LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_CHANGE_APPLICATION
    ) {
      if (
        applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED &&
        licenceStatus === CONST.LICENCE_STATUS_ACTIVE
      ) {
        return true;
      }
    }

    return false;
  };

  const isMainAgentChangeApplicationInProgress = () => {
    const { agencyApplication, agentApplications } = props.welcome;

    if (
      agencyApplication.licencingSubType ===
      CONST.LICENCE_SUB_TYPE_MORTGAGE_LENDER_CHANGE_APPLICATION
    ) {
      return true;
    }

    const mainAgentApplications = agentApplications.filter(
      (app) =>
        app.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
        app.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
    );

    if (mainAgentApplications.length === 2) {
      const draftApplications = mainAgentApplications.filter(
        (app) =>
          app.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION &&
          app.licenceStatus === CONST.LICENCE_STATUS_NEW &&
          app.applicationStatus === CONST.APPLICATION_STATUS_PENDING_PAYMENT
      );

      const activeApplications = mainAgentApplications.filter(
        (app) =>
          app.licenceStatus === CONST.LICENCE_STATUS_ACTIVE &&
          app.applicationStatus === CONST.APPLICATION_STATUS_APPROVED_ISSUED
      );

      return draftApplications.length === 1 && activeApplications.length === 1;
    }

    return false;
  };

  const legalName =
    props.welcome.agencyApplication?.businessLicenceData?.companyRjscDetails?.businessData
      ?.businessOwner;

  const addMoreButtonTitle = () => {
    switch (applicationType) {
      case CONST.APPLICATION_TYPE_COLLECTION_AGENCY:
        return "Add new collector";
      case CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY:
        return "Add new debt management agent";
      case CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE:
        return "Add a new broker";
      default:
        return "Add more";
    }
  };

  const changeMainAgentButtonTitle = () => {
    switch (applicationType) {
      case CONST.APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE:
      case CONST.APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE:
        return "Compliance Officer Change Request";
      default:
        return "Principal Broker Change Request";
    }
  };

  // Agency have PENDING_AGENCY_LICENCE because without Principal broker license,
  // BL admin will not be able to approve
  const showErrorMessageForPrincipalBrokerRenewalPending = () => {
    let principalbrokerbApp;

    if (agentApplications?.length) {
      for (const agentApp of agentApplications) {
        if (
          agentApp.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION ||
          agentApp.licencingSubType === CONST.LICENCE_SUB_TYPE_PRINCIPAL_BROKER_RENEWAL_APPLICATION
        ) {
          principalbrokerbApp = agentApp;
          break;
        }
      }
    }

    if (
      agencyRenewalDetails?.length &&
      applicationType === CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE &&
      (applicationStatus === CONST.APPLICATION_STATUS_PENDING_AGENCY ||
        applicationStatus === CONST.APPLICATION_STATUS_PENDING ||
        applicationStatus === CONST.APPLICATION_STATUS_OPENED ||
        applicationStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        applicationStatus === CONST.APPLICATION_STATUS_UNREAD)
    ) {
      //check agent app principal broker not submitted
      let isPrincipalBrokerRenewalSubmitted = true;
      if (principalbrokerbApp) {
        if (
          principalbrokerbApp.isAgentRenewalEnable &&
          !(
            principalbrokerbApp.licenceStatus === CONST.APPLICATION_STATUS_UNREAD ||
            principalbrokerbApp.licenceStatus === CONST.APPLICATION_STATUS_OPENED ||
            principalbrokerbApp.licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
            principalbrokerbApp.licenceStatus === CONST.APPLICATION_STATUS_SUBMITTED
          )
        ) {
          isPrincipalBrokerRenewalSubmitted = false;
        }
      }

      if (isPrincipalBrokerRenewalSubmitted) {
        return null;
      }

      return (
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>{ErrorMark()}</div>
          <div class="ns-error-message">
            The <b>Mortgage Brokerage Licence</b> renewal will not be approved by Business Licensing
            until the Principal Broker Licence is submitted for renewal and all other required
            documents are submitted.
          </div>
        </div>
      );
    } else if (
      props.welcome.isRenewalEnable &&
      (principalbrokerbApp?.licenceStatus === CONST.APPLICATION_STATUS_PENDING ||
        principalbrokerbApp?.licenceStatus === CONST.APPLICATION_STATUS_OPENED ||
        principalbrokerbApp?.licenceStatus === CONST.APPLICATION_STATUS_UNDER_REVIEW ||
        principalbrokerbApp?.licenceStatus === CONST.APPLICATION_STATUS_UNREAD)
    ) {
      return (
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px" }}>{ErrorMark()}</div>
          <div class="ns-error-message">
            The <b>Principal Broker Licence</b> renewal will not be approved by Business Licensing
            until the Mortgage Brokerage Licence is submitted for renewal and all other required
            documents are submitted.
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <Navigation {...props} />
      <div className={"container"}>
        <div className="row">
          <div className="col-lg-12 bottomMarginNormal">
            <Header
              id="welcome-header-businessname"
              header={props.welcome.businessName ? props.welcome.businessName : "Company Name"}
            />
            <h3 id="welcome-header-legalname">{legalName ? legalName : ""}</h3>
            {welcomeNoteComponent()}
          </div>
        </div>
        {agencyRenewalDetails?.length > 0 && (
          <>
            <div className="row">
              <div className="col-xs-12 col-md-6 col-lg-3">
                <SubHeader
                  style={{ marginTop: "0px", color: "#555" }}
                  subHeader="Corporate licence renewal"
                />
              </div>
              <div className="col-xs-12 col-md-6 col-lg-5">
                <table className="table welcome">
                  <tbody>
                    {
                      // Can we assume that agencyApplicationDetails will have all fields for principal broker?
                      agencyRenewalDetails.map(({ id, title, text, status }, index) => {
                        const val = getRenewalApplicationDetailValue(id, text, status);
                        return (
                          <React.Fragment key={index + "-frag-status"}>
                            <tr key={index + "-tr"} className={id}>
                              <th key={index + "-th"}>{title}</th>
                              <td key={index + "-td"}>
                                <span className={status ? status.toLowerCase() : ""}>{val}</span>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    }
                  </tbody>
                </table>
              </div>
              <div className="col-xs-12 col-md-12 col-lg-4" style={{ textAlign: "right" }}>
                {renewalApplicationButtonComponent()}
              </div>
              {showErrorMessageForPrincipalBrokerRenewalPending()}
            </div>
            <LineSeperator />
          </>
        )}
        <div className="row">
          <div className="col-xs-12 col-md-6 col-lg-3">
            <SubHeader style={{ marginTop: "0px", color: "#555" }} subHeader="Corporate licence" />
          </div>
          <div className="col-xs-12 col-md-6 col-lg-6">
            <table className="table welcome">
              <tbody>
                {
                  // Can we assume that agencyApplicationDetails will have all fields for principal broker?
                  agencyApplicationDetails.map(({ id, title, text, status }, index) => {
                    const val = getApplicationDetailValue(id, text, status);
                    return (
                      <React.Fragment key={index + "-frag-status"}>
                        <tr key={index + "-tr"} className={id}>
                          <th key={index + "-th"}>{title}</th>
                          <td key={index + "-td"}>
                            <span className={status ? status.toLowerCase() : ""}>{val}</span>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                }
              </tbody>
            </table>
          </div>
          <div className="col-xs-12 col-md-12 col-lg-3" style={{ textAlign: "right" }}>
            {applicationButtonComponent()}
          </div>
        </div>{" "}
        {/* row */}
        {canShowAgentDetailsSection() && (
          <>
            <LineSeperator />
            <div className="row">
              <div className="col-12 right">
                {canAddIndividualAgent() && (
                  <Button
                    id="add-new-collector-button"
                    onClick={handleAddNewAgent}
                    text={addMoreButtonTitle()}
                    buttonType="regular_primary"
                  />
                )}
                {canShowBranchApplications() && (
                  <Button
                    style={{ marginLeft: "20px" }}
                    id="add-new-branch-button"
                    onClick={handleAddNewBranch}
                    text="Add new branch"
                    buttonType="regular_primary"
                  />
                )}
              </div>
            </div>
            <div className="row" style={{ paddingTop: "30px" }}>
              <div className="col-xs-12 col-md- col-lg-3">
                <SubHeader style={{ marginTop: "0px" }} subHeader="Licences and applications" />
                {canShowAgentDetailsSection() && (
                  <>
                    {/*canShowBranchApplications() && (
                      <div className="bottomMarginMedium">
                        <span>
                          <i>Show applications :</i>
                        </span>
                        additionalApplicationTypeSelectionControl()
                      </div>
                    ) */}
                    <span>
                      <i>Sorted by :</i>
                    </span>
                    <div>
                      <fieldset className="ns-fieldset" style={{ marginBottom: "0px" }}>
                        <div className={"ns-radios ns-radios--small"}>
                          {agentFilterOptions?.map((option, index) => {
                            if (
                              !option.canShowOption(props.welcome.additionalApplicationTypeFilter, applicationType)
                            ) {
                              return null;
                            }
                            return (
                              <div key={index} className="ns-radios__item">
                                <React.Fragment key={index + "-frag-filter"}>
                                  <input
                                    className="ns-radios__input"
                                    type="radio"
                                    value={option.id}
                                    id={option.id}
                                    key={option.id + "input"}
                                    name="sort-radio"
                                    checked={option.id === props.welcome.agentSort ? true : false}
                                    onChange={onSortFitlerChange}
                                  />
                                  <label
                                    style={{ paddingLeft: "10px" }}
                                    key={option.id + "label"}
                                    className="ns-radios__label inline"
                                    htmlFor={option.id}
                                  >
                                    {option.textStr(
                                      props.welcome.additionalApplicationTypeFilter,
                                      applicationType
                                    )}
                                  </label>
                                  <br />
                                </React.Fragment>
                              </div>
                            );
                          })}
                        </div>
                      </fieldset>
                      {/* style={{ marginLeft: "2em" }} */}
                      <div>{statusTypeSelectionControl()}</div>
                    </div>
                  </>
                )}
              </div>
              {(canShowAgentDetailsSection() || canShowBranchApplications()) && (
                <div className="col-xs-12 col-md-9 col-lg-9">
                  <div className="applicationDetails">
                    {canShowAgentDetailsSection() && agentApplicationDetailsComponent()}
                    {canShowBranchApplications() && branchApplicationDetailsComponent()}
                  </div>
                </div>
              )}
            </div>
          </>
        )}
        <DocumentViewer
          fileData={documentViewerDocument}
          isOpen={openDocumentViewer}
          fileName={selectedFile?.filename}
          handleClose={() => setOpenDocumentViewer(false)}
        />
        {false && (
          <Modal
            appElement={document.getElementById("root")}
            isOpen={false && showWelcomeDialog}
            contentLabel="welcomeDialog"
            onRequestClose={() => {
              setShowWelcomeDialog(false);
            }}
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            className="modalDialogContent welcomeModalDialog"
            closeTimeoutMS={150}
          >
            <Header header={welcome?.dialog?.header} />
            <p dangerouslySetInnerHTML={{ __html: welcome?.dialog?.htmlText }}></p>
            <Button
              id="start-application-modal-button"
              onClick={() => {
                props.dispatch(resetWelcomeDialogDisplay(applicationType));
                props.dispatch(
                  push(replaceUrlParams(welcome.navigation.next, applicationType, applicationMode))
                );
              }}
              buttonType={"regular_primary"}
              text={
                applicationType === CONST.APPLICATION_TYPE_COLLECTION_AGENCY
                  ? "Start Application"
                  : applicationType === CONST.APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY
                  ? "Start Application"
                  : "Start Application"
              }
              style={{ marginTop: "20px" }}
            />
          </Modal>
        )}
        {/*
        <Modal
          appElement={document.getElementById("root")}
          isOpen={showLicenceCancelDialog}
          contentLabel="cancelLicenceDialog"
          onRequestClose={() => {
            setShowLicenceCancelDialog(false);
          }}
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
          className="modalDialogContent welcomeModalDialog"
          overlayClassName="modalOverlayClassName"
          closeTimeoutMS={150}
        >
          <div className="row pull-right">
            <div
              className="col-lg-1 closeButton"
              onClick={() => {
                setShowLicenceCancelDialog(false);
              }}
            >
              <i className="fa fa-2x fa-times"></i>
            </div>
          </div>
          <Header header={"Cancel Licence"} />
          <p>{"Are sure that you want to cancel the licence?"}</p>
          <Button
            onClick={() => {
              handleCancelAgencyLicence();
            }}
            buttonType={"regular_primary"}
            text="Yes"
            style={{ marginTop: "20px" }}
          />
          <Button
            onClick={() => {
              setShowLicenceCancelDialog(false);
            }}
            buttonType={"regular_primary"}
            text="No"
            style={{ marginTop: "20px", marginLeft: 50 }}
          />
        </Modal>
        */}
      </div>
    </>
  );
}

export default connect(welcomeSelect)(Welcome);
